document.addEventListener('DOMContentLoaded', () => {
  const aToggle = document.querySelector('.iRHVRDfBpAPGwvNv6');
  const wToggle = document.querySelector('.iVMN8XBHnjLIlRQL5');

  if (!aToggle || !wToggle) return;

  const init = () => {
    const allColorPickers = document.querySelectorAll(
      '[data-instant-option-name="Farbe"]'
    );
    if (!allColorPickers.length) return;

    const applyState = (activePicker) => {
      const activeValue = (activePicker.getAttribute('data-instant-option-value') || '').toLowerCase();
      const isWhite = activeValue.includes('white');
      aToggle.setAttribute('data-instant-state', isWhite ? 'inactive' : 'active');
      wToggle.setAttribute('data-instant-state', isWhite ? 'active' : 'inactive');
    };

    const alreadyActive = document.querySelector(
      '[data-instant-option-name="Farbe"][data-instant-state="active"]'
    );

    if (alreadyActive) {
      applyState(alreadyActive);
      return;
    }

    let attempts = 0;
    const poll = setInterval(() => {
      attempts++;
      const nowActive = document.querySelector(
        '[data-instant-option-name="Farbe"][data-instant-state="active"]'
      );
      if (nowActive) {
        clearInterval(poll);
        applyState(nowActive);
        return;
      }
      if (attempts > 30) clearInterval(poll);
    }, 100);
  };

  init();
});

// MASSE DYNAMISCHE BESCHRIFTUNG
document.addEventListener('DOMContentLoaded', () => {
  const sizePickers = document.querySelectorAll('[data-instant-option-name="Ma%C3%9Fe"]');

  function updateSizeClass(element) {
    const sizeValue = element.getAttribute('data-instant-option-value');
    if (!sizeValue) return;

    const cleanSize = 'ppm-size-' + sizeValue.replace(' m', '').replace(' ', '');

    document.body.classList.forEach((cls) => {
      if (cls.startsWith('ppm-size-')) document.body.classList.remove(cls);
    });

    document.body.classList.add(cleanSize);
  }

  const activeOnLoad = document.querySelector(
    '[data-instant-option-name="Ma%C3%9Fe"][data-instant-state="active"]'
  );
  if (activeOnLoad) updateSizeClass(activeOnLoad);

  sizePickers.forEach((picker) => {
    picker.addEventListener('click', () => {
      setTimeout(() => updateSizeClass(picker), 10);
    });
  });
});

// INSTANT + INFINITE COMBO
document.addEventListener('DOMContentLoaded', () => {
  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim();
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const parseMasse = (raw) => {
    const m = String(raw || '').match(/(\d+(?:[.,]\d+)?)\s*x\s*(\d+(?:[.,]\d+)?)/i);
    if (!m) return null;

    const a = parseFloat(m[1].replace(',', '.'));
    const b = parseFloat(m[2].replace(',', '.'));
    if (!Number.isFinite(a) || !Number.isFinite(b)) return null;

    return {
      kurz: Math.min(a, b),
      lang: Math.max(a, b)
    };
  };

  const getActiveMasseValue = () => {
    const active = document.querySelector(
      '[data-instant-option-name="Ma%C3%9Fe"][data-instant-state="active"]'
    );
    return active?.getAttribute('data-instant-option-value') || null;
  };

  const waitForMasseChange = async (prev, tries = 30, delay = 30) => {
    for (let i = 0; i < tries; i++) {
      const cur = getActiveMasseValue();
      if (cur && cur !== prev) return cur;
      await sleep(delay);
    }
    return getActiveMasseValue();
  };

  const getSideFromAccordionItem = (item) => {
    const img = item?.querySelector('img[src*="seitenschutz-"]');
    const src = img?.getAttribute('src') || '';
    const m = src.match(/seitenschutz-(hinten|rechts|links|vorne)\.svg/i);
    return m ? m[1].toLowerCase() : null;
  };

  const getTypeFromOptionEl = (optEl) => {
    const t = norm(optEl?.innerText || '').toLowerCase();
    if (!t) return null;
    if (t.includes('ohne')) return null;
    if (t.includes('verglasung')) return 'Verglasung';
    if (t.includes('manuell')) return 'Seitenschutz manuell';
    if (t.includes('elektrisch')) return 'Seitenschutz elektrisch';
    return null;
  };

  const getLengthForSide = (side, masse) => {
    if (!masse) return null;
    const val = side === 'links' || side === 'rechts' ? masse.kurz : masse.lang;
    return String(Math.round(val));
  };

  const ioRoot = document.querySelector('#infiniteoptions-container');
  if (!ioRoot) return;

  const allCheckboxes = () =>
    Array.from(ioRoot.querySelectorAll('input[type="checkbox"]'));

  const checkboxesForSide = (side) => {
    const suffix = `- ${side}`;
    return allCheckboxes().filter((cb) => norm(cb.value).endsWith(suffix));
  };

  const findDesiredCheckbox = (meters, typeLabel, side) => {
    const wanted = norm(`${meters}m ${typeLabel} - ${side}`);
    return (
      allCheckboxes().find((cb) => norm(cb.value) === wanted) || null
    );
  };

  const waitForIoSideCheckboxes = (tries = 40, delay = 100) =>
    new Promise((resolve) => {
      let count = 0;
      const poll = setInterval(() => {
        count++;
        const ready = allCheckboxes().some((cb) =>
          /-\s*(hinten|rechts|links|vorne)\s*$/i.test(norm(cb.value))
        );

        if (ready) {
          clearInterval(poll);
          resolve(true);
          return;
        }

        if (count >= tries) {
          clearInterval(poll);
          resolve(false);
        }
      }, delay);
    });

  const state = {
    hinten: null,
    rechts: null,
    links: null,
    vorne: null
  };

  let applying = false;
  let pending = false;
  let debounceTimer = null;

  const runApplyAll = async () => {
    if (applying) {
      pending = true;
      return;
    }

    applying = true;

    try {
      for (const side of ['hinten', 'rechts', 'links', 'vorne']) {
        await setSideCheckbox(side, state[side]);
        await sleep(80);
      }
    } finally {
      applying = false;
      if (pending) {
        pending = false;
        scheduleApplyAll();
      }
    }
  };

  const scheduleApplyAll = () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(runApplyAll, 120);
  };

  const setSideCheckbox = async (side, typeLabel) => {
    const masse = parseMasse(getActiveMasseValue());
    const meters = getLengthForSide(side, masse);
    if (!meters) return;

    const sideCbs = checkboxesForSide(side);

    if (!typeLabel) {
      for (const cb of sideCbs) {
        if (cb.checked) {
          const y = window.scrollY;
          (cb.closest('label') || cb).click();
          await sleep(60);
          window.scrollTo(0, y);
        }
      }
      return;
    }

    const desired = findDesiredCheckbox(meters, typeLabel, side);
    if (!desired) return;

    for (const cb of sideCbs) {
      if (cb.checked && cb !== desired) {
        const y = window.scrollY;
        (cb.closest('label') || cb).click();
        await sleep(60);
        window.scrollTo(0, y);
      }
    }

    if (!desired.checked) {
      const y = window.scrollY;
      (desired.closest('label') || desired).click();
      await sleep(80);
      window.scrollTo(0, y);
    }
  };

  const accordionItems = Array.from(
    document.querySelectorAll('[data-instant-type="accordion-item"]')
  ).filter((item) => item.querySelector('img[src*="seitenschutz-"]'));

  const refreshFancyUiAvailability = () => {
    const masse = parseMasse(getActiveMasseValue());
    if (!masse) return;

    const cbs = allCheckboxes();
    const sideCheckboxesReady = cbs.some((cb) =>
      /-\s*(hinten|rechts|links|vorne)\s*$/i.test(norm(cb.value))
    );

    if (!sideCheckboxesReady) return;

    accordionItems.forEach((item) => {
      const side = getSideFromAccordionItem(item);
      if (!side) return;

      const meters = getLengthForSide(side, masse);
      if (!meters) return;

      const optionBlocks = Array.from(
        item.querySelectorAll(
          '[data-instant-type="accordion-content"] [data-instant-type="container"]'
        )
      );

      optionBlocks.forEach((optEl) => {
        const typeLabel = getTypeFromOptionEl(optEl);

        if (!typeLabel) {
          optEl.classList.remove('is-unavailable');
          return;
        }

        const desired = findDesiredCheckbox(meters, typeLabel, side);
        optEl.classList.toggle('is-unavailable', !desired);

        if (!desired && optEl.getAttribute('data-instant-state') === 'active') {
          optEl.setAttribute('data-instant-state', 'inactive');
          state[side] = null;
        }
      });
    });
  };

  const setDefaultOhneVerglasung = () => {
    accordionItems.forEach((item) => {
      const side = getSideFromAccordionItem(item);
      if (!side) return;

      const optionBlocks = Array.from(
        item.querySelectorAll(
          '[data-instant-type="accordion-content"] [data-instant-type="container"]'
        )
      );

      const activeBlock = optionBlocks.find(
        (el) => el.getAttribute('data-instant-state') === 'active'
      );

      if (activeBlock) {
        state[side] = getTypeFromOptionEl(activeBlock);
        return;
      }

      const ohneBlock = optionBlocks.find((el) =>
        norm(el.innerText).toLowerCase().includes('ohne')
      );

      if (!ohneBlock) return;

      optionBlocks.forEach((x) => x.setAttribute('data-instant-state', 'inactive'));
      ohneBlock.setAttribute('data-instant-state', 'active');
      state[side] = null;
    });
  };

  accordionItems.forEach((item) => {
    const side = getSideFromAccordionItem(item);
    if (!side) return;

    const optionBlocks = Array.from(
      item.querySelectorAll(
        '[data-instant-type="accordion-content"] [data-instant-type="container"]'
      )
    );

    optionBlocks.forEach((optEl) => {
      optEl.addEventListener('click', (e) => {
        if (optEl.classList.contains('is-unavailable')) {
          e.preventDefault();
          return;
        }

        const linkish = e.target.closest("a, button, [role='link']");
        if (linkish) e.preventDefault();

        const typeLabel = getTypeFromOptionEl(optEl);

        optionBlocks.forEach((x) => x.setAttribute('data-instant-state', 'inactive'));
        optEl.setAttribute('data-instant-state', 'active');

        state[side] = typeLabel;
        scheduleApplyAll();
      });
    });
  });

  const sizePickers = document.querySelectorAll(
    '[data-instant-option-name="Ma%C3%9Fe"]'
  );

  if (sizePickers.length) {
    let lastMasse = getActiveMasseValue();

    const obs = new MutationObserver(async (mutations) => {
      if (!mutations.some((m) => m.attributeName === 'data-instant-state')) return;

      const next = await waitForMasseChange(lastMasse);
      if (!next || next === lastMasse) return;

      lastMasse = next;
      refreshFancyUiAvailability();
      scheduleApplyAll();
    });

    sizePickers.forEach((el) =>
      obs.observe(el, {
        attributes: true,
        attributeFilter: ['data-instant-state']
      })
    );
  }

  (async () => {
    setDefaultOhneVerglasung();
    await waitForIoSideCheckboxes();
    refreshFancyUiAvailability();
    scheduleApplyAll();
  })();
});

// UPDATE PRICE
(function () {
  const SOURCE_SEL = '.infiniteoptions-price .price-item--regular';
  const TARGETS = [
    'h2[data-instant-dynamic-content-source="PRICE"]',
    'p[data-instant-dynamic-content-source="PRICE"]'
  ];

  let isInternalWrite = false;

  const syncPrice = () => {
    const source = document.querySelector(SOURCE_SEL);
    if (!source || isInternalWrite) return;

    const newPrice = source.textContent.trim();
    if (!newPrice) return;

    TARGETS.forEach((sel) => {
      const el = document.querySelector(sel);
      if (el && el.textContent.trim() !== newPrice) {
        isInternalWrite = true;
        el.textContent = newPrice;
        setTimeout(() => {
          isInternalWrite = false;
        }, 50);
      }
    });
  };

  const init = setInterval(() => {
    const sourceWrap = document.querySelector('.infiniteoptions-price');
    if (!sourceWrap) return;

    clearInterval(init);
    const observer = new MutationObserver(syncPrice);
    observer.observe(sourceWrap, {
      childList: true,
      subtree: true,
      characterData: true
    });
    syncPrice();
  }, 50);
})();

// NATIVE ATC BUTTON (Infinite Options Kompatibilität)
document.addEventListener('DOMContentLoaded', () => {
  const waitForButton = setInterval(() => {
    const instantBtn = document.querySelector(
      '[data-instant-action-type="redirect-to-cart"]'
    );
    const form = document.querySelector('form[data-instant-form-product-id]');

    if (!instantBtn || !form) return;
    clearInterval(waitForButton);

    const variantInput = document.createElement('input');
    variantInput.type = 'hidden';
    variantInput.name = 'id';
    variantInput.value = form.getAttribute('data-instant-form-variant-id');
    form.appendChild(variantInput);

    const variantObserver = new MutationObserver(() => {
      const newId = form.getAttribute('data-instant-form-variant-id');
      if (newId) variantInput.value = newId;
    });

    variantObserver.observe(form, {
      attributes: true,
      attributeFilter: ['data-instant-form-variant-id']
    });

    instantBtn.style.display = 'none';

    const nativeBtn = document.createElement('button');
    nativeBtn.type = 'button';
    nativeBtn.className = instantBtn.className;
    nativeBtn.innerHTML = instantBtn.innerHTML;
    instantBtn.parentNode.insertBefore(nativeBtn, instantBtn);

    nativeBtn.addEventListener('click', async () => {
      const formData = new FormData();
      const vid =
        new URLSearchParams(window.location.search).get('variant') ||
        form.getAttribute('data-instant-form-variant-id');

      formData.append('id', vid);
      formData.append(
        'quantity',
        form.querySelector('[name="quantity"]')?.value || 1
      );

      const ioContainer = document.querySelector('#infiniteoptions-container');
      if (ioContainer) {
        ioContainer.querySelectorAll('input[type="hidden"]').forEach((input) => {
          if (input.name) formData.append(input.name, input.value);
        });
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!response.ok) {
          console.error('Cart add failed:', response.status);
          return;
        }

        const cartSidebar = document.querySelector('sidebar-drawer.site-cart-sidebar');
        if (cartSidebar) {
          cartSidebar.dispatchEvent(
            new CustomEvent('theme:cart:open', { bubbles: true })
          );
          cartSidebar.setAttribute('open', '');
          document.dispatchEvent(new CustomEvent('theme:cart:open'));
        }
      } catch (err) {
        console.error('Cart error:', err);
      }
    });
  }, 200);
});

// PV CARPORT BREAK
document.addEventListener('DOMContentLoaded', function () {
  const productTitle = document.querySelector('.ppm-product-info h1');
  if (!productTitle) return;

  const originalText = productTitle.innerHTML;
  const newText = originalText.replace(' PV-Carport', '<br/>PV-Carport');
  productTitle.innerHTML = newText;
});


// MONTAGE TOGGLE + ADDON ADD + AUTO CLEANUP
document.addEventListener('DOMContentLoaded', () => {
  const ENABLE_MONTAGE_TOGGLE = true;
  if (!ENABLE_MONTAGE_TOGGLE) return;

  const ADDON_VARIANT_ID = 56556351291716;

  const fake = document.getElementById('ppm-montage-toggle');
  const form = document.querySelector('form[data-instant-form-product-id]');
  if (!fake || !form) return;

  let addonFlowRunning = false;
  let cleanupRunning = false;

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  const isChecked = () => {
    return fake.getAttribute('data-checked') === 'true';
  };

  const setChecked = (checked) => {
    fake.setAttribute('data-checked', checked ? 'true' : 'false');

    const box = fake.querySelector('.ppm-checkbox');
    if (box) {
      box.classList.toggle('is-active', checked);
    }
  };

  const getCurrentMainVariantId = () => {
    return (
      new URLSearchParams(window.location.search).get('variant') ||
      form.getAttribute('data-instant-form-variant-id')
    );
  };

  const getCart = async () => {
    const res = await fetch(`${window.Shopify.routes.root}cart.js`, {
      credentials: 'same-origin'
    });

    if (!res.ok) {
      throw new Error(`Cart fetch failed: ${res.status}`);
    }

    return res.json();
  };

  const cartHasVariant = (cart, variantId) => {
    return (cart.items || []).some(
      (item) => Number(item.variant_id) === Number(variantId)
    );
  };

  const findVariantLine = (cart, variantId) => {
    return (cart.items || []).find(
      (item) => Number(item.variant_id) === Number(variantId)
    ) || null;
  };

  const cartHasAnyCaroItem = (cart) => {
    return (cart.items || []).some((item) => {
      const title = String(item.product_title || item.title || '').toLowerCase();
      return title.includes('caro');
    });
  };

  const addAddonIfMissing = async () => {
    const cart = await getCart();
    if (cartHasVariant(cart, ADDON_VARIANT_ID)) return;

    const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: ADDON_VARIANT_ID,
            quantity: 1
          }
        ]
      })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Montage add failed: ${res.status} ${text}`);
    }
  };

  const removeAddonIfPresent = async () => {
    const cart = await getCart();
    const montageLine = findVariantLine(cart, ADDON_VARIANT_ID);
    if (!montageLine) return;

    const res = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: montageLine.key,
        quantity: 0
      })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Montage remove failed: ${res.status} ${text}`);
    }
  };

  const cleanupMontageIfNoCaro = async () => {
    if (cleanupRunning) return;
    cleanupRunning = true;

    try {
      const cart = await getCart();
      if (cartHasAnyCaroItem(cart)) return;

      const montageLine = findVariantLine(cart, ADDON_VARIANT_ID);
      if (!montageLine) return;

      await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: montageLine.key,
          quantity: 0
        })
      });
    } catch (err) {
      console.error('Montage cleanup failed:', err);
    } finally {
      cleanupRunning = false;
    }
  };

  const waitUntilMainProductIsInCart = async (mainVariantId, tries = 30, delay = 250) => {
    for (let i = 0; i < tries; i++) {
      try {
        const cart = await getCart();
        if (cartHasVariant(cart, mainVariantId)) return true;
      } catch (err) {
        console.error('Cart poll failed:', err);
      }
      await sleep(delay);
    }
    return false;
  };

  // init from markup
  setChecked(isChecked());

  // checkbox = UI only
  fake.addEventListener('click', (e) => {
    e.preventDefault();
    setChecked(!isChecked());
  });

  // main product add flow
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('button.ppm-buy-button');
    if (!btn) return;

    if (addonFlowRunning) return;

    const wantMontage = isChecked();
    const mainVariantId = getCurrentMainVariantId();
    if (!mainVariantId) return;

    addonFlowRunning = true;

    try {
      const mainAdded = await waitUntilMainProductIsInCart(mainVariantId);

      if (!mainAdded) {
        addonFlowRunning = false;
        return;
      }

      if (wantMontage) {
        await addAddonIfMissing();
      } else {
        await cleanupMontageIfNoCaro();
      }
    } catch (err) {
      console.error('Montage add-on flow failed:', err);
    } finally {
      addonFlowRunning = false;
    }
  });

  // cleanup after cart interactions
  document.addEventListener('click', () => {
    setTimeout(() => {
      cleanupMontageIfNoCaro();
    }, 700);
  });

  // initial cleanup on load
  cleanupMontageIfNoCaro();
});

/**
 * CART PRICE SYNC - INSTANT OVERLAY EDITION
 * Specifically targets the "Entfernen" and Quantity buttons in your HTML.
 */
class CartPriceSync {
  constructor() {
    this.headerSelector = '.icLgm1iKNwKVr9T5g';
    this.cartUrl = `${window.Shopify?.routes?.root || '/'}cart.js`;
    this.isUpdating = false;
  }

  formatEuro(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(cents / 100);
  }

  async refresh() {
    if (this.isUpdating) return;
    this.isUpdating = true;

    try {
      const response = await fetch(this.cartUrl, { cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      
      const displayPrice = this.formatEuro(cart.total_price);
      const headerElement = document.querySelector(this.headerSelector);
      
      if (headerElement && headerElement.textContent.trim() !== displayPrice) {
        headerElement.textContent = displayPrice;
      }
    } catch (err) {
      console.error('Header Price Sync Error:', err);
    } finally {
      this.isUpdating = false;
    }
  }

  init() {
    // 1. Initial Load
    this.refresh();

    // 2. Global Click Listener for "Instant" Cart Buttons
    document.addEventListener('click', (e) => {
      const target = e.target;
      
      // Check for:
      // - The "Entfernen" button (adjust-line-item-quantity)
      // - Plus/Minus buttons (quantity-increment / quantity-decrement)
      const isInstantAction = target.closest('[data-instant-action-type="adjust-line-item-quantity"]') || 
                              target.closest('[data-instant-action-type="quantity-increment"]') || 
                              target.closest('[data-instant-action-type="quantity-decrement"]');

      if (isInstantAction) {
        // We trigger multiple refreshes because we don't know exactly 
        // how long the "Instant" builder takes to finish its internal update.
        setTimeout(() => this.refresh(), 300);
        setTimeout(() => this.refresh(), 800);
        setTimeout(() => this.refresh(), 1500);
      }
    });

    // 3. Fallback for network-level changes
    const originalFetch = window.fetch;
    window.fetch = (...args) => {
      return originalFetch(...args).then((response) => {
        const url = args[0] instanceof Request ? args[0].url : args[0];
        if (typeof url === 'string' && url.includes('/cart/')) {
          setTimeout(() => this.refresh(), 500);
        }
        return response;
      });
    };
  }
}

// --- INITIALIZE ---
const headerPriceSync = new CartPriceSync();
headerPriceSync.init();